import { BIND_TYPE } from '@constants'

import {
  BindField,
  GANTT_BIND_TYPE_LIST,
  GanttColumnForm,
  GanttFormValuesBack,
} from '@gantt/components/GanttCreateOrEdit'
import { timelineItemTitlesDefaultValue } from '@gantt/constants'

export const getColumnFields = (column: GanttColumnForm): BindField[] => {
  if (column?.fields?.length > 0) {
    return column.fields
  }

  if (column.field?.bindType === GANTT_BIND_TYPE_LIST.FIELD && column.field.field) {
    return [
      {
        ...column.field,
        field: {
          ...column.field.field,
          formatDate: column.formatDate as string,
        },
      },
    ]
  }

  if (column.bindType === BIND_TYPE.JS) {
    return [
      {
        bindType: GANTT_BIND_TYPE_LIST.JS,
        js: column.jsValue,
      },
    ]
  }

  return []
}

export const transformFetchGanttByIdResponse = (baseQueryReturnValue: GanttFormValuesBack) => {
  return {
    ...baseQueryReturnValue,
    resource: {
      ...baseQueryReturnValue.resource,
      columns: baseQueryReturnValue.resource.columns?.map(column => {
        return {
          ...column,
          fields: getColumnFields(column),
        }
      }),
    },
    timeline: baseQueryReturnValue.timeline?.map(item => {
      return {
        ...item,
        titles: !item.titles?.length
          ? structuredClone(timelineItemTitlesDefaultValue)
          : item.titles,
        sections: item.sections?.map(section => {
          return {
            ...section,
            titles: !section.titles?.length
              ? structuredClone(timelineItemTitlesDefaultValue)
              : section.titles,
          }
        }),
      }
    }),
  }
}
